define(['angular', '../module'], function(angular, MODULE_NAME) {
    'use strict';

    var templateUrl = require('../views/alertBanner.template.html');

    angular.module(MODULE_NAME)
        .directive('ilmnUiAlertBanner', function() {
            return {
                controller: UiAlertBannerController,
                controllerAs: 'vm',
                templateUrl: templateUrl,
                scope: false,
                bindToController: {
                    options: '=',
                    close: '&'
                }
            }
        });

    UiAlertBannerController.$inject = [];
    function UiAlertBannerController() {
        var vm = this;
        var defaults = {
            type: 'warning',
            iconShow: true
        };

        var Icons = {
            success: 'fa-check-circle',
            info: 'fa-info-circle',
            warning: 'fa-exclamation-circle',
            danger: 'fa-exclamation-circle',
            default: 'fa-info-circle',
            notify: 'fa-exclamation-circle'
        };

        vm.options = angular.extend({}, defaults, vm.options);
        vm.iconClass = Icons[vm.options.type];
        vm.bannerClass = 'ilmn-alert-banner--'+vm.options.type + ' ' + vm.options.class;

        if(vm.options.dismissible) {
            vm.bannerClass += ' ilmn-alert-banner--dismissible';
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-alert-banner/scripts/alertBanner.directive.js
// module id = 38
// module chunks = 0